import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FeedbackModal } from "@/components/FeedbackWidget";

export default function FeedbackPage() {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg-primary)" }}>
      <header className="border-b border-[var(--border)] bg-white/60 backdrop-blur sticky top-0 z-10">
        <div className="max-w-5xl mx-auto flex items-center justify-between h-12 px-4 sm:px-6 font-mono text-[10px] uppercase tracking-[0.24em] text-gray-600">
          <Link to="/" data-testid="feedback-back" className="inline-flex items-center gap-2 hover:text-black">
            <ArrowLeft size={13} strokeWidth={2} /> Fount
          </Link>
          <span>Feedback</span>
          <Link to="/support" className="hover:text-black">Support</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-16 grid grid-cols-1 md:grid-cols-[1.1fr_1fr] gap-10 items-start">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#EC4899] font-semibold">
            Built with creators
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.98] font-semibold mt-3">
            Help us build <br />
            <span
              className="italic"
              style={{
                backgroundImage: "linear-gradient(90deg, #7C3AED 0%, #EC4899 38%, #F43F5E 68%, #F97316 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              your signal.
            </span>
          </h1>
          <p className="text-base text-gray-700 mt-5 leading-relaxed max-w-md">
            Your notes shape what ships next — from talking-point tone
            to niche coverage to email cadence. Bug reports, wishes, praise, hot takes:
            all welcome.
          </p>

          <div className="mt-8 rounded-2xl border border-[var(--border)] bg-white p-5">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-gray-500 font-semibold">
              What we&apos;re listening for
            </div>
            <ul className="mt-3 space-y-2 text-[15px] text-gray-800 leading-relaxed">
              <li>· Talking points that missed your voice — tell us how.</li>
              <li>· A niche or source you wish was covered.</li>
              <li>· Anything that felt slow, confusing, or broken.</li>
              <li>· A creator you want us to build for next.</li>
            </ul>
          </div>
        </div>

        <div>
          <FeedbackModal embedded />
        </div>
      </main>
    </div>
  );
}
